const translations = {
  nav: {
    en: { products: 'Products', why: 'Why Blackline', projects: 'Projects', catalog: 'Catalog', contact: 'Contact', quote: 'Get a Quote' },
    es: { products: 'Productos', why: 'Por Qu\u00e9 Blackline', projects: 'Proyectos', catalog: 'Cat\u00e1logo', contact: 'Contacto', quote: 'Cotizar' }
  },
  trustBar: {
    en: [
      { num: '6', label: 'Product Lines' },
      { num: '2015', label: 'Since' },
      { num: '100%', label: 'Custom Sizing' },
      { num: '\u221e', label: 'Configurations' }
    ],
    es: [
      { num: '6', label: 'L\u00edneas de Producto' },
      { num: '2015', label: 'Desde' },
      { num: '100%', label: 'Medidas a la Orden' },
      { num: '\u221e', label: 'Configuraciones' }
    ]
  },
  products: {
    en: { eyebrow: 'Our Products', title: 'Engineered for Modern Living.', desc: 'A complete range of window and door systems designed for contemporary construction.' },
    es: { eyebrow: 'Nuestros Productos', title: 'Ingenier\u00eda para la Vida Moderna.', desc: 'Una gama completa de sistemas de ventanas y puertas dise\u00f1ados para construcci\u00f3n contempor\u00e1nea.' }
  },
  why: {
    en: {
      eyebrow: 'Why Blackline',
      title: 'Built Different. By Design.',
      items: [
        { num: '01', title: 'Modern Minimalist Systems', desc: 'Slim profiles with maximum glass surface area for clean, uninterrupted sightlines.' },
        { num: '02', title: 'Architectural Glass', desc: 'Tempered and laminated options with advanced sealing for the demands of Texas climate.' },
        { num: '03', title: 'Precision Manufacturing', desc: 'Every frame engineered to exact specifications. High-grade materials with lasting hardware.' },
        { num: '04', title: 'Reliable Supply', desc: 'Consistent inventory and predictable lead times. Simplified sourcing, one partner.' }
      ]
    },
    es: {
      eyebrow: 'Por Qu\u00e9 Blackline',
      title: 'Construido Diferente. Por Dise\u00f1o.',
      items: [
        { num: '01', title: 'Sistemas Minimalistas Modernos', desc: 'Perfiles delgados con m\u00e1xima superficie de vidrio para l\u00edneas de vista limpias.' },
        { num: '02', title: 'Vidrio Arquitect\u00f3nico', desc: 'Opciones templadas y laminadas con sellado avanzado para el clima de Texas.' },
        { num: '03', title: 'Manufactura de Precisi\u00f3n', desc: 'Cada marco fabricado con especificaciones exactas. Materiales de alta calidad.' },
        { num: '04', title: 'Suministro Confiable', desc: 'Inventario consistente y tiempos de entrega predecibles. Un solo socio.' }
      ]
    }
  },
  inlineCta: {
    en: { title: 'Ready to Discuss Your Project?', desc: 'Connect with our team directly. We respond within 24 hours.' },
    es: { title: '\u00bfListo para Hablar de tu Proyecto?', desc: 'Conecta con nuestro equipo directamente. Respondemos en 24 horas.' }
  },
  gallery: {
    en: { eyebrow: 'Projects', title: 'See It Installed.' },
    es: { eyebrow: 'Proyectos', title: 'V\u00e9alo Instalado.' }
  },
  contact: {
    en: {
      eyebrow: 'Get In Touch',
      title: "Let's Talk About Your Project.",
      desc: "Whether you're a builder, architect, or homeowner \u2014 we're here to help bring your vision to life.",
      whatsapp: 'SMS / Text',
      whatsappDesc: 'Message us anytime.',
      email: 'Email',
      callHouston: 'Call Us',
      dallas: 'Dallas',
      sendText: 'Send a Text',
      firstName: 'First Name',
      lastName: 'Last Name',
      emailLabel: 'Email',
      phone: 'Phone',
      iAmA: 'I Am A...',
      projectDetails: 'Tell Us About Your Project',
      submit: 'Send Message \u2192',
      successMsg: 'Message sent! We\'ll be in touch within 24 hours.',
      types: ['Homeowner', 'Builder / Contractor', 'Architect / Designer', 'Developer', 'Other']
    },
    es: {
      eyebrow: 'Cont\u00e1ctanos',
      title: 'Hablemos de tu Proyecto.',
      desc: 'Ya seas constructor, arquitecto o propietario \u2014 estamos aqu\u00ed para ayudarte a hacer realidad tu visi\u00f3n.',
      whatsapp: 'SMS / Texto',
      whatsappDesc: 'Escr\u00edbenos cuando quieras.',
      email: 'Correo',
      callHouston: 'Ll\u00e1manos',
      dallas: 'Dallas',
      sendText: 'Enviar Texto',
      firstName: 'Nombre',
      lastName: 'Apellido',
      emailLabel: 'Correo Electr\u00f3nico',
      phone: 'Tel\u00e9fono',
      iAmA: 'Soy...',
      projectDetails: 'Cu\u00e9ntanos Sobre Tu Proyecto',
      submit: 'Enviar Mensaje \u2192',
      successMsg: '\u00a1Mensaje enviado! Te contactaremos en 24 horas.',
      types: ['Propietario', 'Constructor / Contratista', 'Arquitecto / Dise\u00f1ador', 'Desarrollador', 'Otro']
    }
  },
  locations: {
    en: { eyebrow: 'Locations', title: 'Serving Texas.', getDirections: 'Get Directions \u2192' },
    es: { eyebrow: 'Ubicaciones', title: 'Sirviendo a Texas.', getDirections: 'C\u00f3mo Llegar \u2192' }
  },
  footer: {
    en: {
      tagline: 'Premium window and door systems for modern architecture.',
      productsTitle: 'Products',
      companyTitle: 'Company',
      contactTitle: 'Contact',
      companyLinks: ['About', 'Projects', 'For Builders', 'For Architects', 'Catalog'],
      copyright: '\u00a9 2026 Blackline Premium Solutions. All rights reserved.'
    },
    es: {
      tagline: 'Sistemas premium de ventanas y puertas para arquitectura moderna.',
      productsTitle: 'Productos',
      companyTitle: 'Empresa',
      contactTitle: 'Contacto',
      companyLinks: ['Nosotros', 'Proyectos', 'Para Constructores', 'Para Arquitectos', 'Cat\u00e1logo'],
      copyright: '\u00a9 2026 Blackline Premium Solutions. Todos los derechos reservados.'
    }
  },
  maintenance: {
    en: { title: 'Under Maintenance', desc: 'We\'re making improvements. Please check back soon.', contact: 'For urgent inquiries:' },
    es: { title: 'En Mantenimiento', desc: 'Estamos haciendo mejoras. Por favor, vuelva pronto.', contact: 'Para consultas urgentes:' }
  }
};

export default translations;
